import apiClient from './apiService';

export const getLinkAnalytics   = () => apiClient.get('/analytics/links');
export const getProfileActivity = () => apiClient.get('/analytics/activity');
